import { Controller } from 'stimulus';

export default class extends Controller {
    static targets = [ 'small', 'full' ];

    connect() {
    }

    expand() {
        this.smallTarget.classList.toggle('hidden');
        this.fullTarget.classList.toggle('hidden');
    }
    collapse() {
        this.smallTarget.classList.toggle('hidden');
        this.fullTarget.classList.toggle('hidden');
    }


}
